
<template>
  <!--添加产品-->
  <div>
    <x-addEdit
      :formList="formList"
      :formKey="formKey"
      :addParam="addParam"
      :editParam="editParam"
      :detailParam="detailParam"
    >
    </x-addEdit>
  </div>
</template>
<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'addProduct',
  data () {
    let decoratorOptions = {
      parent_ids: {
        rules: [{required: true, message: '请选择所属分类'}]
      },
      type: {
        rules: [
          {required: true, message: '请输入产品型号'},
          { pattern: this.REG.code, message: this.MESSAGE.code }
        ]
      },
      title: {
        rules: [
          {required: true, message: '请输入产品名称'},
          { pattern: this.REG.name, message: this.MESSAGE.name }
        ]
      },
      description: {
        rules: [{min: 2, max: 20, message: '备注为2-20个字'}]
      },
      status: {
        initialValue: 1,
        rules: []
      }
    };
    return {
      formList: [
        {
          label: '所属分类',
          inputType: 'cascader',
          options: [],
          placeholder: '请选择所属分类',
          fieldNames: {label: 'title', value: 'category_id', children: 'children'},
          props: ['parent_ids', decoratorOptions.parent_ids]
        },
        {
          label: '产品型号',
          inputType: 'input',
          options: [],
          placeholder: '请输入产品型号',
          props: ['type', decoratorOptions.type]
        },
        {
          label: '产品名称',
          inputType: 'input',
          options: [],
          placeholder: '请输入产品名称',
          props: ['title', decoratorOptions.title]
        },
        {
          label: '备注',
          inputType: 'textarea',
          options: [],
          placeholder: '请输入备注',
          props: ['description', decoratorOptions.description]
        },
        {
          label: '状态',
          inputType: 'radioGroup',
          options: this.$store.state.statusList,
          placeholder: '',
          props: ['status', decoratorOptions.status]
        }
      ],
      formKey: {
        parent_ids: '',
        type: '',
        title: '',
        description: '',
        status: ''
      },
      addParam: {
        url: '/product/add',
        reqHandle: '', // this.reqHandle
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/product/edit/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/product/',
        resHandle: '' // this.detailResHandle
      }
    };
  },
  mounted () {
    this.deviceManageSelect([{index: 0, key: 'category', scope: 'formList'}], {category_module: 'product', children_number: 3});
  },
  methods: {
    addResHandle (res) {
      return res;
    },
    reqHandle (param) {
      return param;
    },
    detailResHandle (data) {
    },
    editResHandle (res) {
      return res;
    }
  }
};
</script>
